import React, { useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { roles } from "utils/constant";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { Popover, Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { Button } from "@heroui/react";
import PaymentOutstanding from "./PaymentOutstanding";
import PaymentStatement from "./PaymentStatement";
import { AddCollection } from "./AddCollection";

const CollectionReport: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const tableRef = useRef(null);

  const [invoiceTableData, setInvoiceTableData] = useState<any>([]);
  const [tableDetails, setTableDetails] = useState<any>([]);

  const [startDate, setStartDate] = useState<any>(moment().startOf("day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState<any>(moment().endOf("day").format("YYYY-MM-DD"));
  const [query, setQuery] = useState<any>({
    fromDate: moment().startOf("day"),
    toDate: moment().endOf("day"),
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [fetchedData, setFetchedData] = useState([]);
  const [isDataAdded, setIsDataAdded] = useState(false);

  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const [customerList, setCustomerList] = useState([]);

  const [searchIncrement, setSearchIncrement] = useState(0);
  const [selectedInvoice, setSelectedInvoice] = useState<any>([]);

  const [totalCredit, setTotalCredit] = useState(0);
  const [totalTdsCredit, setTotalTdsCredit] = useState(0);
  const [pendingAmount, setPendingAmount] = useState(0);

  const [invoiceWisePayment, setInvoiceWisePayment] = useState({});
  const [selectedSum, setSelectedSum] = useState<number | null>(null);
  const [showSum, setShowSum] = useState(false);
  const [selectedCellsSet, setSelectedCellsSet] = useState<Set<string>>(new Set());

  useEffect(() => {
    if (!selectedCustomer || !selectedCustomer.value) {
      setSearchIncrement(0);
    }
		setSelectedInvoice([]);
  }, [selectedCustomer]);

  useQuery(["CustomersListApi"], () => ListCommanWay("/admin/customer/list", { isActive: true }, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.id,
            label: p.code + " - " + p.sh,
          });
        });
        setCustomerList(opt);
      }
    },
  });

	useEffect(() => {
		console.log("Selected Invoices changed:", selectedInvoice);
	}, [selectedInvoice]);

  const exportToExcel = () => {
    const table = tableRef.current;

    if (!table) {
      UseToast("No data available to export", "error");
      return;
    }

    const tableClone = table.cloneNode(true);

    // Remove elements with ignore-excel class if any
    const toIgnore = tableClone.querySelectorAll(".ignore-excel");
    toIgnore.forEach((el) => el.remove());

    // Convert table to worksheet
    const ws = utils.table_to_sheet(tableClone);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, "Collection Report");

    // Clean up cell properties
    Object.keys(ws).forEach((key) => {
      if (key.startsWith("!")) return;

      let cell = ws[key];
      if (cell && cell.h && typeof cell.h === "string") {
        cell.h = null;
      }
      if (cell && cell.l) {
        delete cell.l;
      }
    });

    // Generate Excel file
    const wbout = write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, `Collection_Report_${moment().format("DD-MM-YYYY")}.xlsx`);
  };

  return (
    <>
      <h1 className="text-center mb-2 mt-3 text-lg font-semibold ">Collection Report</h1>
      <div className="flex items-end flex-col gap-4 m-2 rounded-md">
        <div className="flex gap-1 items-center flex-wrap border p-2 rounded-xl bg-gray-200 border-blue-600 w-full">
          <div className={`inline-flex items-center gap-2 mr-6`}>
            <label className="text-sm font-semibold text-gray-900 whitespace-nowrap">Select Customer</label>
            <Select
              className={`bg-gray-50 border-gray-300 text-gray-900 text-sm rounded-lg block w-72 z-20`}
              options={customerList}
              isClearable={true}
              onChange={(e: any) => {
                setSelectedCustomer(e);
              }}
              value={selectedCustomer}
            />
          </div>
          <div className="flex- hidden items-center ml-12 gap-4">
            <div className="flex gap-4 w-full flex-1 items-center">
              <label className=" text-sm font-semibold text-gray-900 whitespace-nowrap">From Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-36 p-2.5`}
                placeholder="Start Date"
                name="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="flex gap-4 w-full flex-1 items-center">
              <label className="text-sm font-semibold text-gray-900 whitespace-nowrap">To Date</label>
              <input
                type="date"
                className={`bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-36 p-2.5`}
                placeholder="End Date"
                name="endDate"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
          </div>

          <Button
            size="md"
            color="primary"
            onPress={() => {
              setSearchIncrement(searchIncrement + 1);
            }}
            disabled={selectedCustomer?.value ? false : true}
            className={!selectedCustomer?.value ? "opacity-50 cursor-not-allowed" : ""}
          >
            Search
          </Button>
          <Button size="md" color="success" onPress={exportToExcel}>
            Excel Export
          </Button>
          <AddCollection invoiceData={""} tableData={invoiceTableData} selectedInvoice={selectedInvoice} />
        </div>
      </div>
      <div className="">
        {selectedCustomer?.value ? (
          <PaymentStatement
            searchIncrement={searchIncrement}
            customerId={selectedCustomer?.value}
            selectedInvoice={selectedInvoice}
            setSelectedInvoice={setSelectedInvoice}
						setInvoiceTableData={setInvoiceTableData}
            tableRef={tableRef}
          />
        ) : (
          <PaymentOutstanding />
        )}
      </div>
    </>
  );
};

export default CollectionReport;
